import { useEffect } from 'react'
import type { ToastItem } from 'react-toastify'
import { toast } from 'react-toastify'

export const useToastCountManager = (limit: number = 6) => {
  useEffect(() => {
    const toastArr: ToastItem<{}>[] = []
    toast.onChange((payload) => {
      if (payload.status === 'added') {
        toastArr.push(payload)
      }

      // status 'removed' 이벤트 캐치를 제대로 못해서 생긴 코드
      const overflow = toastArr.length - limit

      if (overflow > 0) {
        Array.from({ length: overflow }).forEach((i) => {
          const oldestToast = toastArr.shift()
          if (oldestToast) {
            toast.dismiss(oldestToast.id)
          }
        })
      }
    })
  }, [])
}
